import { useMemo } from 'react'
import cn from 'classnames'
import KeyboardNavigator from 'components/KeyboardNavigator'
import { decorateFilterInMenu } from 'util/search/filter'
import { intersperse } from 'util/arrays'
import { styles } from './styles'
import oldStyles from './styles.css'

export default function SearchFor({
  onSubmit,
  searchQuery,
  currentSubmittedTicketSearchFilterMatches,
  className,
}) {
  const searchQueryWithFilters = useMemo(
    () => {
      return intersperse(
        currentSubmittedTicketSearchFilterMatches.map(match => (
          <span key={match} className="search-filter">
            {match}
          </span>
        )),
        ' '
      )
    },
    [currentSubmittedTicketSearchFilterMatches]
  )

  return (
    <KeyboardNavigator.Item
      active
      activeClassName={oldStyles.SearchSuggestions_activeSubmitSuggestion}
      onSelect={onSubmit}
      className={className}
    >
      <div
        className={cn(
          oldStyles.SearchSuggestions_suggestion,
          oldStyles.SearchSuggestions_submitSuggestion,
          oldStyles.SearchSuggestions_ready
        )}
      >
        <div
          className={cn(
            oldStyles.hint,
            oldStyles.SearchSuggestions_suggestionHint
          )}
        >
          Show all results for
        </div>
        <div
          className={cn(
            oldStyles.suggestion,
            oldStyles.SearchSuggestions_suggestionQuery,
            'grui truncate'
          )}
          css={styles.innerList}
        >
          <>
            {searchQueryWithFilters}
            {` `}
            {
              <span
                /* eslint-disable-next-line react/no-danger */
                dangerouslySetInnerHTML={{
                  __html: decorateFilterInMenu(searchQuery),
                }}
              />
            }
          </>
        </div>
      </div>
    </KeyboardNavigator.Item>
  )
}
